import axios from 'axios';

const fetchData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BILLING_BASE_URL}selfserve/products`);
    return response.data.data;
  } catch (error) {
    console.error('Unable to get the data', error);
  }
  return null;
};

const fetchPeacockData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BILLING_BASE_URL}selfserve/peacock-products`);
    return response.data.data;
  } catch (error) {
    console.error('Unable to get the data', error);
  }
  return null;
};

const fetchLeadSources = () => {
  try {
    return axios.get(`${process.env.REACT_APP_BILLING_BASE_URL}selfserve/lead-sources`);
  } catch (error) {
    console.error('Unable to get the data', error);
  }
  return null;
};

export { fetchData, fetchPeacockData, fetchLeadSources };
